<script setup>
import { computed, ref } from 'vue';
import { useStore, useStoreGetters } from 'dashboard/composables/store.js';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';

import Switch from 'next/switch/Switch.vue';

const props = defineProps({
  config: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();
const store = useStore();
const getters = useStoreGetters();

const wgptIntegrationsUiFlags = getters['wgptIntegrations/getUIFlags'];

const isUpdating = computed(() => wgptIntegrationsUiFlags.value.isUpdatingZid);

const showOrders = ref(!props.config?.hide_orders_in_sidebar);

const handleToggle = async () => {
  const newValue = !showOrders.value;
  try {
    await store.dispatch('wgptIntegrations/updateZidSettings', {
      hide_orders_in_sidebar: !newValue,
    });
    showOrders.value = newValue;
    useAlert(t('WGPT_INTEGRATIONS.ZID.EDITOR.API.SUCCESS_MESSAGE'));
  } catch (error) {
    const errorMessage =
      error?.message || t('WGPT_INTEGRATIONS.ZID.EDITOR.API.ERROR_MESSAGE');
    useAlert(errorMessage);
  }
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-2">
      <h3 class="text-base font-medium leading-6 text-n-slate-12">
        <span class="truncate">{{
          t('WGPT_INTEGRATIONS.ZID.EDITOR.SETTINGS.ORDERS.TITLE')
        }}</span>
      </h3>
      <p class="mb-0 text-sm text-n-slate-11">
        {{ t('WGPT_INTEGRATIONS.ZID.EDITOR.SETTINGS.ORDERS.DESCRIPTION') }}
      </p>
    </div>

    <div class="flex items-center gap-3">
      <Switch
        :model-value="showOrders"
        :disabled="isUpdating"
        @click="handleToggle"
      />
      <span class="text-sm text-n-slate-12">
        {{
          showOrders
            ? t('WGPT_INTEGRATIONS.ZID.EDITOR.SETTINGS.ORDERS.ENABLED')
            : t('WGPT_INTEGRATIONS.ZID.EDITOR.SETTINGS.ORDERS.DISABLED')
        }}
      </span>
    </div>
  </div>
</template>
